<template>
  <div class="ppv-filter-group">
    <div class="ppv-filter-label">{{ $t("ppv.filters.patient_track") }}</div>
    <div class="ppv-chips-row">
      <PpvChip
        v-for="track in trackOptions"
        :key="track.value"
        variant="track"
        :selected="isSelected(track.value)"
        :icon="track.icon"
        @click="onToggle(track.value)"
      >
        {{ $t(track.label) }}
      </PpvChip>
    </div>
  </div>
</template>

<script>
import PpvChip from '../shared/PpvChip.vue'

export default {
  name: 'PpvTrackFilter',
  components: { PpvChip },
  props: {
    selectedTracks: { type: Array, default: () => [] },
    trackOptions: { type: Array, required: true },
    onToggle: { type: Function, required: true },
  },
  methods: {
    isSelected(value) {
      return this.selectedTracks.includes(value)
    }
  }
}
</script>

<style scoped>
.ppv-filter-group {
  margin-bottom: 20px;
}
.ppv-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #8a96a8;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  text-transform: uppercase;
}
.ppv-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
</style>
